<script lang="ts">
	import md from '$lib/utils/md';
	import { getCopy } from '$lib/lang/copy.svelte';
	import Section from '$lib/components/fragments/Section.svelte';
	import Headline from '$lib/components/fragments/Headline.svelte';
	import Callout from '$lib/components/fragments/Callout.svelte';
	import Picture from '$lib/components/media/Picture.svelte';
	import RiskFactorsChart from '$lib/components/charts/RiskFactorsChart.svelte';

	const copy = $derived(getCopy().risk_factors);
	const captionOneWidth = 15;
	const captionTwoWidth = 17;

	let showCaptionOne = $state(false);
	let showCaptionTwo = $state(false);
</script>

<Section id="forces" class="bg-blue text-white">
	<div class="content-well-sm">
		<Headline overline={copy.overline} title={copy.title} dark />
		<p class="body-1">{@html md(copy.copy_before)}</p>
	</div>

	<RiskFactorsChart />
	
	<div class="content-well-sm">
		<p class="source"><i>{@html md(copy.source)}</i></p>
	</div>

	<div class="content-well-sm">
		<p class="body-1">{@html md(copy.copy_middle)}</p>
	</div>

	<Callout class="py-12">
		<div class="heading-6 max-w-md">{@html md(copy.callout.text)}</div>
		{#snippet image()}
			<figure class="relative" role="img" aria-label="Nestle image with translation overlay">
				<Picture src="nestle.webp" alt={copy.callout.alt} class="w-full max-w-90" />
				<div class="absolute top-1 left-[22%]">
					<div class="h-12 bg-white/40 py-1" style={`width: ${captionOneWidth}rem`}></div>
				</div>
				<div class="absolute top-1/5 left-1/5">
					<div class="mt-2 h-12 bg-white/40 py-1" style={`width: ${captionTwoWidth}rem`}></div>
				</div>
				<div
					role="region"
					class="absolute top-1 left-[22%] flex h-12 w-fit items-center justify-center bg-white/80 p-1 transition-opacity duration-300"
					class:opacity-0={!showCaptionOne}
					class:opacity-100={showCaptionOne}
					style={`width: ${captionOneWidth}rem`}
					onmouseenter={() => (showCaptionOne = true)}
					onmouseleave={() => (showCaptionOne = false)}
				>
					<span class="subtitle-1 w-full text-center text-black">
						{@html md(copy.callout.img_1)}
					</span>
				</div>
				<div
					role="region"
					aria-label="caption"
					class="absolute top-1/5 left-1/5 mt-2 flex h-12 items-center bg-white/80 p-1 transition-opacity duration-300"
					class:opacity-0={!showCaptionTwo}
					class:opacity-100={showCaptionTwo}
					style={`width: ${captionTwoWidth}rem`}
					onmouseenter={() => (showCaptionTwo = true)}
					onmouseleave={() => (showCaptionTwo = false)}
				>
					<span class="microcopy-2 block text-center leading-tight text-black">
						{@html md(copy.callout.img_2)}
					</span>
				</div>
				<div class="subtitle-2 text-yellow mt-3 font-bold">
					<p>{@html md(copy.callout.caption)}</p>
					<p class="microcopy-2 text-gray mt-2">{copy.callout.hover}</p>
				</div>
			</figure>
		{/snippet}
	</Callout>

	<div class="content-well-sm">
		<p class="body-1">{@html md(copy.copy_after)}</p>
	</div>
</Section>
